<template>
	<div v-if="eyedis.print" class="eyedis-panel">
		<div class="container flex">
			<div class="fonts">
				<span class="title">Размер шрифта:</span>
				<a @click.prevent="() => setEyedis('fonts', 'first')" class="first round"
					:class="{ active: eyedis.fonts === 'first' }">а</a>
				<a @click.prevent="() => setEyedis('fonts', 'second')" class="second round"
					:class="{ active: eyedis.fonts === 'second' }">а</a>
				<a @click.prevent="() => setEyedis('fonts', 'third')" class="third round"
					:class="{ active: eyedis.fonts === 'third' }">а</a>
			</div>
			<div class="colors">
				<span class="title">Цвет сайта:</span>
				<a @click.prevent="() => setEyedis('colors', 'first')" class="first round"
					:class="{ active: eyedis.colors === 'first' }">ц</a>
				<a @click.prevent="() => setEyedis('colors', 'second')" class="second round"
					:class="{ active: eyedis.colors === 'second' }">ц</a>
				<a @click.prevent="() => setEyedis('colors', 'third')" class="third round"
					:class="{ active: eyedis.colors === 'third' }">ц</a>
			</div>
			<div class="images flex">
				<span class="title">Изображения:</span>
				<a @click.prevent="() => setEyedis('images', !eyedis.images)" class="images_turn"
					:class="{ left: eyedis.images, right: !eyedis.images }">
					<span class="ident turn-on">Выкл.</span>
					<span class="cursor"><span></span></span>
					<span class="ident turn-off">Вкл.</span>
				</a>
			</div>
		</div>
	</div>
	<div class="page-header">
		<div id="sticky-wrapper" class="sticky-wrapper is-sticky">
			<div class="sticky-header stick" id="header">

				<div class="header-bar visible-lg">
					<div class="select-catalog">
						<a href="https://www.gorodperm.ru/" class="header__title">Сайт муниципального образования город
							Пермь</a>

					</div>

					<div class="header-link hall">
						<router-link :to="`${basePath}/`" class="icon-mail">Интернет-приемная</router-link>
					</div>

					<RegistrarAppLink :ipData="ipData" />

					<div class="auth">
						<a @click.prevent="() => setEyedis('print', false)" class="ed-visible-inline eyedis-trigger"
							id="eyedisTriggerButtonOff">
							Вернуться на обычную версию сайта
						</a>
						<div v-if="isAuth">
							<a :href="logoutUrl" @click.stop="logout" class="icon-auth">Выйти</a>
						</div>
						<div v-else>
							<a :href="redirectUrl" class="icon-auth">Войти</a>
						</div>
					</div>
				</div>

				<div class="nav menu visible-lg">
					<router-link :to="`${basePath}/`" class="logo-title">Интернет-приемная<br>администрации города
						Перми</router-link>
					<ul>
						<li class="userData">
							<br>
							<span>
								{{ name }} {{ roleName }}
							</span>
							<div>
								<span class="subValue">
									{{ sub }} {{ ip }}
								</span>
							</div>
						</li>
					</ul>

				</div>

				<div class="header-mobile hidden-lg">
					<div class="organs">
						<div class="organs-select">
							<router-link :to="`${basePath}/`" class="modal-more-trigger logo-title">
								Интернет-приемная<br>администрации города Перми
							</router-link>
						</div>
					</div>


					<div class="auth">
						<a class="icon-auth-m" href="#!"></a>
					</div>

					<div class="open-menu">
						<a href="#" class="modal-more-trigger icon-more" v-bind:class="{ active: menuShown }"
							@click.stop="toggleMenu">
							<span></span>
						</a>
					</div>
					<VerticalMenu class="dropdown-menu" v-if="menuShown" :routes="routes" @clicked="menuShown = false" />
				</div>
			</div>
		</div>
	</div>
</template>	

<script>
import { getFullName, getRedirectUrl, logout, getLogoutUrl, getUsername, getConfig, getFields, getUserRole } from '@/auth';
import authMixin from '@/mixins/authMixin'
import RegistrarAppLink from './RegistrarAppLink.vue'
import VerticalMenu from './VerticalMenu.vue';

const getRoleName = (role) => {
	if (role === 'admin') {
		return '[Администратор]'
	}
	if (role === 'registrar') {
		return '[Регистратор]'
	}

	return ''
}

const getSub = (role) => {
	if (role === 'registrar' || role === 'admin') {
		return getUsername()
	}

	return getFields().sub
}

export default {
	mixins: [
		authMixin
	],
	props: ['eyedis', 'setEyedis', 'ipData', 'routes'],
	components: {
		RegistrarAppLink,
		VerticalMenu
	},
	data() {
		return {
			name: '',
			sub: '',
			redirectUrl: '',
			logoutUrl: getLogoutUrl(),
			basePath: getConfig().basePath,
			roleName: '',
			ip: '',
			menuShown: false,
		}
	},
	created() {
		this.ip = this.ipData.ip

		if (this.isAuth) {
			const name = getFullName();
			this.name = name ? name : getUsername();

			const role = getUserRole()
			this.roleName = getRoleName(role)
			this.sub = getSub(role)

			// if (location.href.indexOf(getConfig().registrarPath) === -1 && (role === 'registrar')) {
			// 	window.location.href = getConfig().registrarPath + '/'
			// }
		} else {
			getRedirectUrl().then(redirectUrl => {
				this.redirectUrl = redirectUrl
			})
		}
	},
	methods: {
		logout: function () {
			logout();
		},
		toggleMenu: function () {
			this.menuShown = !this.menuShown
		}
	}
}
</script>

<style>
.sticky-header {
	/*position: fixed;*/
	top: 0px;
	z-index: auto;
	width: 100%;
}

.subValue {
	font-size: smaller;
	color: #cccccc;
}

.userData {
	text-align: right;
}

.dropdown-menu {
	position: absolute;
	top: 50px;
}
</style>